// Applies SEO / site-meta settings to the document <head> at runtime.
import { api } from "./api";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setFavicon(href) {
  if (!href) return;
  document.head.querySelectorAll("link[rel~='icon']").forEach((l) => l.parentNode.removeChild(l));
  const link = document.createElement("link");
  link.rel = "icon";
  link.href = href;
  document.head.appendChild(link);
}

export function applySiteMeta(s) {
  if (!s) return;
  if (s.title) {
    document.title = s.title;
    upsertMeta("property", "og:title", s.title);
    upsertMeta("name", "twitter:title", s.title);
  }
  if (s.description != null) {
    upsertMeta("name", "description", s.description);
    upsertMeta("property", "og:description", s.description);
    upsertMeta("name", "twitter:description", s.description);
  }
  if (s.keywords != null) upsertMeta("name", "keywords", s.keywords);
  if (s.theme_color) upsertMeta("name", "theme-color", s.theme_color);
  if (s.og_image) {
    upsertMeta("property", "og:image", s.og_image);
    upsertMeta("name", "twitter:image", s.og_image);
    upsertMeta("name", "twitter:card", "summary_large_image");
  }
  if (s.favicon) setFavicon(s.favicon);
}

export async function loadAndApplySiteMeta() {
  try {
    const { data } = await api.get("/site-settings/public");
    applySiteMeta(data);
  } catch {
    /* ignore — keep index.html defaults */
  }
}
